import {writable, Writable} from "svelte/store";

/**
 * @param {string} localStorageKey The localStorageKey this should be saved under.
 * @param initial The initial value.
 * @returns A writable store, with a get method.
 *  If the initial value is an array, the push method is added.
 *  If the initial value is a date, the value when read from local storage is parsed into a date.
 */
export function storable<T>(localStorageKey: string, initial: T): Writable<T> {
    // @ts-ignore
    if (typeof storable.usedKeys == 'undefined') {
        // It has not... perform the initialization
        // @ts-ignore
        storable.usedKeys = [];
    }
    // @ts-ignore
    if (storable.usedKeys.includes(localStorageKey)) {
        console.log('Err: cannot use the same key')
    }
    // @ts-ignore
    storable.usedKeys.push()
    let initial_value = initial;
    try {
        initial_value = JSON.parse(localStorage[localStorageKey] ? localStorage[localStorageKey] : JSON.stringify(initial));
    } catch (e) {
        console.log('Could not parse initial value of ' + localStorageKey + ' as JSON')
    }
    if (initial instanceof Date) {
        console.log(initial_value)
        // @ts-ignore
        const b = initial_value.split(/\D+/);
        initial_value = (new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6])) as T)
    }
    const ret = writable(initial_value);
    ret.subscribe((value) => localStorage.setItem(localStorageKey, JSON.stringify(value)))
    if (Array.isArray(initial_value)) {
        // @ts-ignore
        ret.push = (push_me: T) => ret.update(e => {
            // @ts-ignore
            e.push(push_me);
            return e;
        })
    }
    return ret;
}